<div class="container">
  <h3 class="text-primary ab_left_text">Software Installation
  </h3>
  <blockquote class="generic-blockquote">
    Installing the Efuelite Solutions Compliance Planet Standard Software is done by certified
    engineers from Efuelite Solutions LTD.
  </blockquote>
</div>